import React from "react";

import { mergeKpiConfigs } from "../config";

const KpiIcon = ({ icon, iconConfig, option }) => {
  ({ iconConfig } = mergeKpiConfigs(option, {
    iconConfig,
  }));
  return (
    <div className={iconConfig.wrapperClassName}>
      <span className={`material-symbols-outlined ${iconConfig.className}`}>
        {icon}
      </span>
    </div>
  );
};

export default KpiIcon;
